import { render, staticRenderFns } from "./landingLight.vue?vue&type=template&id=140b31d5&scoped=true"
import script from "./landingLight.vue?vue&type=script&lang=js"
export * from "./landingLight.vue?vue&type=script&lang=js"
import style0 from "./landingLight.vue?vue&type=style&index=0&id=140b31d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140b31d5",
  null
  
)

export default component.exports